<template>
  <div class="wm-toggle-wrapper"
  v-if="(content.FieldValues.Parameters.hideForLoggedOut === 'true' && loggedIn) || content.FieldValues.Parameters.hideForLoggedOut !== 'true'">
    <div class="wm-toggle">
        <input class="wm-toggle-checker" type="checkbox"
        :id="`pctoggle_chbx_tcs`"
        :checked="content.FieldValues.Parameters.forceOpen === 'true'">
        <label :for="`pctoggle_chbx_tcs`" class="wm-toggle-label">{{ content.FieldValues.Title }}<i class="theme-up"></i><i
            class="theme-down"></i></label>
        <div class="wm-toggle-txt"
        v-html="content.FieldValues.Text">
        </div>
      </div>
  </div>
</template>
<script>
import store from './../store';

export default {
  props: ["content"],
  computed: {
    loggedIn() {
      return store.getters.isLoggedIn;
    }
  },
};
</script>
<style lang="scss">
.wm-toggle-wrapper {
  box-sizing: border-box;
  margin: 0 auto;
  max-width: 955px;
  padding: 0 15px 10px;

  .wm-toggle {
    -webkit-animation: androidBugfix infinite 1s;
    border-bottom: 1px solid var(--pb-terms-toggle-border);
    border-top: 1px solid var(--pb-terms-toggle-border);
  
    .wm-toggle-txt {
      background: var(--pb-terms-text-bg);
      color: var(--pb-terms-text-color);
      display: none;
      font-family: 'Roboto Condensed', Verdana, Arial, Helvetica, sans-serif;
      padding: 1rem 0.5rem;
      a {
        color: var(--pb-terms-text-anchor-color);
        text-decoration: underline;
      }
      ol {
        padding-left: 20px;
        li {
          list-style: decimal;
        }
      }
      ul {
        padding-left: 20px;
        li {
          list-style: circle;
        }
      }
    }
    > .wm-toggle-txt {
      line-height: 1.4;
      padding: 0 1rem;
    }
    > .wm-toggle-label {
      background: var(--pb-terms-toggle-bg);
      border: 0;
      color: var(--pb-terms-toggle-color);
      cursor: pointer;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.1;
      margin: 0;
      padding: 16px 8px;
      position: relative;
      display: block;
      [class*='theme-'] {
        bottom: 0;
        height: 1rem;
        margin: auto;
        position: absolute;
        right: 1rem;
        top: 0;
      }
      .theme-up {
        display: none;
      }
      &:before {
        display: none;
      }
    }
    > .wm-toggle-checker:checked ~ {
      .wm-toggle-txt {
        display: block;
        padding: 0 10px 10px;
      }
    }
    > .wm-toggle-checker:checked + .wm-toggle-label {
      .theme-up {
        display: inline-block;
      }
      .theme-down {
        display: none;
      }
    }
  }
}
.wm-toggle-checker {
  pointer-events: all;
  opacity: 0;
  overflow: visible;
  display: none;
}
</style>
